import { Injectable } from '@angular/core';
import { Firestore, collection, doc, getDoc, getDocs, addDoc, updateDoc, deleteDoc, deleteField, where, query }
from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { IBasicUser, IUser } from '../../../shared/models/users/user.model';
import { IRole, Roles } from '../../../shared/models/users/constants/roles';



@Injectable({
    providedIn: 'root'
})
export class UserService {
    private readonly collectionName = 'users';

    constructor(private firestore: Firestore) { }

    // Create a new user
  async createUser(
        accountId: string,
        user: Omit<IUser, 'id' | 'password' | 'createdAt' | 'updatedAt' | 'status'>
    ): Promise<string> {

        const userCollection = collection(this.firestore, this.collectionName);

        const userWithDates = {
            ...user, // <-- فيه role الصح اللي جاي من الفورم
            createdAt: new Date(),
            updatedAt: new Date(),
            status: 'active',
            accountId: accountId
        };

        const docRef = await addDoc(userCollection, userWithDates);
        return docRef.id;
    }


    // Get all users
    async getAllUsers(): Promise<IUser[]> {
        const userCollection = collection(this.firestore, this.collectionName);
        const querySnapshot = await getDocs(userCollection);
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        } as IUser));
    }

    async getMyUsers(accountId:string): Promise<IUser[]> {
        const userCollection = collection(this.firestore, this.collectionName);
        const q = query(userCollection, where('accountId', '==', accountId));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        } as IUser));
    }


    //     async getEmployee(): Promise<IBasicUser[]> {
    //     const userCollection = collection(this.firestore, this.collectionName);
    //     const q = query(userCollection, where('userType', '==', 'Employee'));
    //     const querySnapshot = await getDocs(q);
    //     return querySnapshot.docs.map(doc => ({
    //         // id: doc.id,
    //         ...doc.data()
    //     } as IBasicUser));
    // }

    // Get user by ID
    async getUserById(id: string): Promise<IUser | null> {
        const userDoc = doc(this.firestore, this.collectionName, id);
        const userSnapshot = await getDoc(userDoc);

        if (!userSnapshot.exists()) {
            return null;
        }

        return {
            id: userSnapshot.id,
            ...userSnapshot.data()
        } as IUser;
    }



async getUserName(firstName: string, lastName: string): Promise<IUser | null> {
  const usersRef = collection(this.firestore, this.collectionName);
  const q = query(
    usersRef,
    where('firstName', '==', firstName),
    where('lastName', '==', lastName)
  );

  const querySnapshot = await getDocs(q);

  if (querySnapshot.empty) {
    return null;
  }

  const docSnap = querySnapshot.docs[0];

  return {
    id: docSnap.id,
    ...docSnap.data()
  } as IUser;
}


    // Update user
    async updateUser(id: string, updates: Partial<IUser>): Promise<void> {
        const userDoc = doc(this.firestore, this.collectionName, id);
        const updatesWithTimestamp = {
            ...updates,
            updatedAt: new Date()
        };

        await updateDoc(userDoc, updatesWithTimestamp);
    }

    async updateUserRole(userId: string, role: IRole): Promise<void> {
        const userDoc = doc(this.firestore, this.collectionName, userId);
        return updateDoc(userDoc, {
            role: role
        } as any);
    }

    // Delete user
    async deleteUser(id: string): Promise<void> {
        const userDoc = doc(this.firestore, this.collectionName, id);
        await deleteDoc(userDoc);
    }

    // Get user by email
    async getUserByEmail(email: string): Promise<IUser | null> {
        const userCollection = collection(this.firestore, this.collectionName);
        const q = query(userCollection, where('email', '==', email));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            return null;
        }

        const doc = querySnapshot.docs[0];
        return {
            id: doc.id,
            ...doc.data()
        } as IUser;
    }

    /** Get all users assigned to a given position (by position id). */
    async getUsersByPositionId(positionId: string): Promise<IUser[]> {
        const userCollection = collection(this.firestore, this.collectionName);
        const q = query(userCollection, where('position', '==', positionId));
        const snapshot = await getDocs(q);
        return snapshot.docs.map((d) => ({
            id: d.id,
            ...d.data()
        } as IUser));
    }

    /** Set or clear a user's position. Pass null to clear. */
    async setUserPosition(userId: string, positionId: string | null): Promise<void> {
        const userDoc = doc(this.firestore, this.collectionName, userId);
        if (positionId == null) {
            await updateDoc(userDoc, { position: deleteField(), updatedAt: new Date() });
        } else {
            await this.updateUser(userId, { position: positionId });
        }
    }
}
